import React from 'react';
import { useUnit } from 'effector-react';
import { $isLoading, $loadingText } from '../stores/loadingStore';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className = '' }) => {
  const isLoading = useUnit($isLoading);
  const loadingText = useUnit($loadingText);

  if (!isLoading) {
    return null;
  }

  return (
    <div className={`loading-overlay ${className}`}>
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <div className="loading-text">{loadingText}</div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
